import messages from './cmsCatalog.json' with { type: 'json' };

export const cmsCatalogFi: Readonly<typeof messages> = messages;
